var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"button-demo"}},[_c('button-group-basic'),_c('button-group-toolbar'),_c('button-group-size'),_c('button-group-vertical')],1)}
var staticRenderFns = []

export { render, staticRenderFns }